"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var _Messages = {
  'online': 'Online',
  'offline': 'Offline',
  'away': 'Away',
  'dnd': 'Do not disturb'
};

var FeAvatar =
/*#__PURE__*/
function (_Component) {
  _inherits(FeAvatar, _Component);

  function FeAvatar(props) {
    var _this;

    _classCallCheck(this, FeAvatar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FeAvatar).call(this, props));
    _this.state = {
      hideImage: _this.props.userInfo.imageUrl ? false : true
    };
    _this.onerrorImage = _this.onerrorImage.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FeAvatar, [{
    key: "onerrorImage",
    value: function onerrorImage(evt) {
      this.setState({
        hideImage: evt.type === 'error'
      });
    }
  }, {
    key: "getImage",
    value: function getImage() {
      return _react.default.createElement("img", {
        alt: "".concat(this.props.userInfo.userName),
        src: this.props.userInfo.imageUrl,
        className: "fe-avatar__img",
        onError: this.onerrorImage,
        onLoad: this.onloadImage
      });
    }
  }, {
    key: "getStatus",
    value: function getStatus() {
      if (!this.props.status) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "fe-avatar__status",
        title: _Messages[this.props.status]
      });
    }
  }, {
    key: "getInitials",
    value: function getInitials() {
      var user = this.props.userInfo.userName.split(' ');
      var initials = "".concat(user[0][0]).concat(user[1] && user[1][0] || '');
      return _react.default.createElement("div", {
        className: "fe-avatar__initials"
      }, _react.default.createElement("span", null, initials));
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return _react.default.createElement("div", {
        className: "fe-avatar__label"
      }, _react.default.createElement("span", {
        className: "fe-avatar__label-name"
      }, this.props.userInfo.userName), _react.default.createElement("span", {
        className: "fe-avatar__label-description"
      }, this.props.userInfo.description));
    }
  }, {
    key: "getAvatar",
    value: function getAvatar() {
      var className = (0, _classnames.default)('fe-avatar__circle', {
        'fe-avatar__circle--no-image': this.state.hideImage
      });
      var image = !this.state.hideImage && this.getImage();
      var status = this.getStatus();
      var initials = this.getInitials();
      return _react.default.createElement("div", {
        className: className
      }, image, status, initials);
    }
  }, {
    key: "render",
    value: function render() {
      /** Minimum condition required to render*/
      if (!this.props.userInfo.userName) {
        return null;
      }
      /** Rendering of component */


      var className = (0, _classnames.default)('fe-avatar', _defineProperty({
        'fe-avatar--small': this.props.isSmall,
        'fe-avatar__label--vertical': !this.props.isSmall && this.props.isLabelVisible && !this.props.isLabelInline,
        'fe-avatar__label--horizontal': !this.props.isSmall && this.props.isLabelVisible && this.props.isLabelInline
      }, "fe-avatar--".concat(this.props.status), this.props.status), this.props.className);
      var avatar = this.getAvatar();
      var label = this.props.isLabelVisible && !this.props.isSmall && this.getLabel();
      var avatarProps = Object.assign({}, this.props);
      delete avatarProps.isSmall;
      delete avatarProps.status;
      delete avatarProps.isLabelInline;
      delete avatarProps.isLabelVisible;
      delete avatarProps.userInfo;
      delete avatarProps.className;
      return _react.default.createElement("div", _extends({}, avatarProps, {
        className: className
      }), avatar, label);
    }
  }]);

  return FeAvatar;
}(_react.Component);

FeAvatar.defaultProps = {
  userInfo: {
    userName: '',
    description: '',
    imageUrl: null
  },
  isLabelVisible: false,
  isLabelInline: true,
  isSmall: false
};
FeAvatar.propTypes = {
  /** Provide user related information like userName, description and imageUrl*/
  userInfo: _propTypes.default.exact({
    userName: _propTypes.default.string,
    description: _propTypes.default.string,
    imageUrl: _propTypes.default.string
  }).isRequired,

  /** Provide user current status like "online", "offline", "away", "dnd"*/
  status: _propTypes.default.oneOf(['online', 'offline', 'away', 'dnd']),

  /** Set true/false to change label visibility*/
  isLabelVisible: _propTypes.default.bool,

  /** Set true/false to change label alignment*/
  isLabelInline: _propTypes.default.bool,

  /** Set true/false to change avatar size*/
  isSmall: _propTypes.default.bool
};
FeAvatar.displayName = 'FeAvatar';
var _default = FeAvatar;
exports.default = _default;